import types from './types'
import PlanAPI from 'api/plans'

/**
 * Upsert modules
 * @param {Object} modules
 */
const update = (plan) => ({
  type: types.update,
  plan,
})

/**
 * Get current plan info
 * @returns Promise<boolean>
 */
const getCurrentPlan = () => async (dispatch) => {
  try {
    const data = await PlanAPI.getCurrent()

    dispatch(update(data.plan))

    return true
  } catch(error) {
    return false
  }
}

export default {
  getCurrentPlan,
  update
}
